export default class Navigation {
    constructor(el, options) {
        this.el = el;
        this.options = options;

        this.active = false;

        this.ui = {};
        this.bindUi();

        this.bindEventListener();
    }

    bindUi() {
        // @todo: get child node from this.el.
        this.ui.burger  = this.el.querySelectorAll('.nav-burger')[0];
        this.ui.links = this.el.querySelectorAll('.nav-content a');
        this.ui.header = document.querySelectorAll('body > header')[0];
    }

    bindEventListener() {
        this.ui.burger.addEventListener('click', () => this.toggle());

        this.ui.links.forEach($item => $item.addEventListener('click', () => this.hide()));

        window.addEventListener('scroll', (e) => {
            if (window.scrollY >= this.ui.header.clientHeight) {
                this.el.classList.add('fixed');
            } else {
                this.el.classList.remove('fixed');
            }
        });
    }

    toggle() {
        this.active ? this.hide() : this.show();
    }

    show() {
        // Scroll to top.
        if (window.scrollY < this.ui.header.clientHeight) {
            window.scroll(0, this.ui.header.clientHeight);
        }

        this.el.classList.add('show');
        document.body.classList.add('no-scroll');
        this.active = true;
    }

    hide() {
        this.el.classList.remove('show');
        document.body.classList.remove('no-scroll');
        this.active = false;
    }
}



// WEBPACK FOOTER //
// ./source/_assets/js/components/Navigation.js